<template>
  <el-pagination
    v-if="total > 0"
    v-model:current-page="currentPage"
    :page-sizes="pageSizes"
    :page-size="pageSize"
    :pager-count="pagerCount"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    :hide-on-single-page="hideOnSinglePage"
    @size-change="changeSize"
    @current-change="changeCurrent"
  />
</template>
<script lang="ts">
  import {
    defineComponent, reactive, toRefs, watch,
  } from 'vue';

  export default defineComponent({
    name: 'base-pagination',
    props: {
      // 只有一页时是否隐藏
      hideOnSinglePage: {
        type: Boolean,
        default: false,
      },
      pageNum: {
        type: Number,
        default: 1,
      },
      pageSize: {
        type: Number,
        default: 20,
      },
      pageSizes: {
        type: Array,
        default: () => undefined,
      },
      total: {
        type: Number,
        default: 0,
      },
      pagerCount: {
        type: Number,
        default: 5,
      },
    },
    emits: {
      'size-change': null,
      'current-change': null,
    },
    setup(props, ctx) {
      const state = reactive({
        currentPage: 1,
      });

      watch(() => props.pageNum, (newVal) => {
        state.currentPage = newVal;
      }, {
        immediate: true,
      });

      function changeSize(value: number) {
        console.log('changeSize---',value)
        ctx.emit('size-change', value);
      }

      function changeCurrent(value: number) {
        ctx.emit('current-change', value);
      }

      return {
        ...toRefs(state),
        changeSize,
        changeCurrent,
      };
    },
  });
</script>
